<template>
    <div class="detail-customer-info">
        <div class="CustomerFullName">
            <div class="pb-3 pr-0 form-group">
                <label class="col-md-12 pl-0 pr-0 pt-1 col-sm-3 control-label text-left mb-0 font-weight-bold">Họ tên<span style="color:red;">*</span>:</label>
                <input type="text"
                       class="form-control input-vxr"
                       placeholder="Họ tên"
                       v-model.trim="name">
                <div v-if="v.name.$error">
                    <span class="error" v-if="!v.name.required">Họ tên không được để trống</span>
                    <span class="error" v-if="!v.name.minLength">Họ tên phải có ít nhất {{v.name.$params.minLength.min}} kí tự.</span>
                </div>
            </div>
            <div class="pb-3 pr-0 form-group">
                <label class="col-md-12 pl-0 pr-0 pt-1 col-sm-3 control-label text-left mb-0 font-weight-bold">Số điện thoại người đi <span style="color:red;">*</span>:</label>
                <input type="number"
                       class="form-control input-vxr"
                       inputmode="numeric"
                       pattern="[0-9]*"
                       placeholder="Số điện thoại người đi"
                       v-model.trim="phone_number">
                <div v-if="v.phone_number.$error">
                    <span class="error" v-if="!v.phone_number.required">SDT không được để trống</span>
                </div>
            </div>
            <div class="pb-1 pr-0 form-group">
                <label class="col-md-12 pl-0 pr-0 pt-1 col-sm-3 control-label text-left mb-0 font-weight-bold">Ghi
                    chú:</label>
                <textarea type="text"
                          class="form-control input-vxr"
                          rows="2"
                          placeholder="Ghi chú"
                          v-model.trim="note">
                </textarea>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {MixinHelper} from "../../../shared/services";
    export default {
        name: "CustomerInfo",
        mixins: [MixinHelper],
        props: {
            value: {
                type: Object,
            },
            v: {
                type: Object,
                required: true
            }
        },
        created() {
            if (this.isAuthenticated) {
                this.name = this.getProp(this.userData, 'name', '');
                this.phone_number = this.getProp(this.userData, 'phone_number', '');
            }
        },
        computed: {
            ...mapGetters(['isAuthenticated', 'userData']),
            name: {
                get() {
                    return this.value.name;
                },
                set(val) {
                    this.v.name.$touch();
                    this.value.name = val;
                    this.$emit('input', this.value)
                }
            },
            phone_number: {
                get() {
                    return this.value.phone_number;
                },
                set(val) {
                    this.v.phone_number.$touch();
                    this.value.phone_number = val;
                    this.$emit('input', this.value)
                }
            },
            note: {
                get() {
                    return this.value.note;
                },
                set(val) {
                    this.v.note.$touch();
                    this.value.note = val;
                    this.$emit('input', this.value)
                }
            },
        }
    }
</script>
<style>
    .error {
        padding-top: 2px;
        color: #f93529;
    }
</style>
<style scoped>
    .detail-customer-info .form-group {
        margin-left: 0 !important;
        margin-right: 0 !important;
        margin-bottom: 0 !important;
    }
    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
</style>
